import React from "react";
import { useTranslation } from "react-i18next";
import { Clock } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../../components/ui/select";
import { cn } from "../../../../../lib/utils";

interface BookingTimeSelectProps {
  availableSlots: string[];
  value: string;
  onChange: (value: string) => void;
  availableDurations: number[];
  disabled?: boolean;
  label: string;
  formControlClassName?: string;
}

const BookingTimeSelect: React.FC<BookingTimeSelectProps> = React.memo(
  (props: BookingTimeSelectProps) => {
    const { t } = useTranslation();

    const handleValueChange = (value: string) => {
      props.onChange(value);
    };

    return (
      <div className={cn("flex flex-col gap-2", props.formControlClassName)}>
        <label className="text-sm font-medium text-slate-900">
          {props.label}
          <span className="text-red-500 ml-1">*</span>
        </label>
        <Select
          value={props.value || "0"}
          onValueChange={handleValueChange}
          disabled={props.disabled}
        >
          <SelectTrigger
            className="w-full h-14 text-base border rounded-xl bg-white text-slate-900 border-black"
            aria-label={props.label}
          >
            <div className="flex items-center gap-2 w-full">
              <Clock className="h-5 w-5 text-slate-600 shrink-0" />
              <SelectValue placeholder={props.label} />
            </div>
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="0">
              <span className="text-slate-500">{props.label}</span>
            </SelectItem>
            {props.availableSlots.map((timeSlot) => (
              <SelectItem key={timeSlot} value={timeSlot}>
                {timeSlot} {t("formats.time_postfix")}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    );
  }
);

export default BookingTimeSelect;
